'use strict';
class $79ddc07166f96a54$export$70ffa26850098d01 {
    /**
     * @private
     * @param {number | bigint | string} value
     * */ constructor(value){
        this._value = BigInt(value);
    }
    /**
     * @param {string} input
     * @returns {[Integer, Error | null]} integer and error tuple
     */ static from_binary(input) {
        if (!input) return [
            new $79ddc07166f96a54$export$70ffa26850098d01(0),
            null
        ];
        if (!$79ddc07166f96a54$var$is_binary(input)) return [
            new $79ddc07166f96a54$export$70ffa26850098d01(0),
            new Error(`Expected binary number, received: ${input}`)
        ];
        let decimal = BigInt(0);
        let index = 0;
        let bit = input.length - 1;
        while(bit >= 0){
            if (input[index] === '1') decimal += BigInt(2) ** BigInt(bit);
            index += 1;
            bit -= 1;
        }
        return [
            new $79ddc07166f96a54$export$70ffa26850098d01(decimal),
            null
        ];
    }
    /**
     * @param {number | string | bigint} input
     * @returns {[Integer, Error | null]}
     */ static create(input) {
        const value = typeof input !== 'string' ? String(input) : input;
        if (value.includes('.') || value.includes(',')) return [
            new $79ddc07166f96a54$export$70ffa26850098d01(0),
            new Error(`Expected an integer, received: ${value}`)
        ];
        return [
            new $79ddc07166f96a54$export$70ffa26850098d01(value),
            null
        ];
    }
    /**
     * @returns {bigint}
     */ decimal() {
        //TODO: Return string
        return this._value;
    }
    /**
     * @returns {string}
     */ binary() {
        let current = this._value;
        const quotient = BigInt(2);
        let result = '';
        while(current !== BigInt(0)){
            result = Number(current % quotient) + result;
            current /= quotient;
        }
        return result || '0';
    }
    /**
     * @returns {boolean}
     */ is_zero() {
        return this._value === BigInt(0);
    }
}
/**
 * @param {string} input
 * @returns {boolean}
 */ function $79ddc07166f96a54$var$is_binary(input) {
    return /^[01]+$/.test(input); //
}


'use strict';
function $f13660fa0986c002$export$21c0ac7fe1cef1b8(_a, _b) {
    const [a, b] = $f13660fa0986c002$export$949614a019c2b52f(_a.binary(), _b.binary());
    let result = '';
    for(let index = 0; index < a.length; index += 1)if (a[index] === '1' && b[index] === '1') result += '1';
    else result += '0';
    return (0, $79ddc07166f96a54$export$70ffa26850098d01).from_binary(result);
}
function $f13660fa0986c002$export$252bb8b3bbdf6749(_a, _b) {
    const [a, b] = $f13660fa0986c002$export$949614a019c2b52f(_a.binary(), _b.binary());
    let result = '';
    for(let index = 0; index < a.length; index += 1)if (a[index] === '1' || b[index] === '1') result += '1';
    else result += '0';
    return (0, $79ddc07166f96a54$export$70ffa26850098d01).from_binary(result);
}
function $f13660fa0986c002$export$6444ef5cd411280c(_a, _b) {
    const [a, b] = $f13660fa0986c002$export$949614a019c2b52f(_a.binary(), _b.binary());
    let result = '';
    for(let index = 0; index < a.length; index += 1)if (a[index] === '1' && b[index] === '0' || a[index] === '0' && b[index] === '1') result += '1';
    else result += '0';
    return (0, $79ddc07166f96a54$export$70ffa26850098d01).from_binary(result);
}
function $f13660fa0986c002$export$10921b7922033856(a, b) {
    return (0, $79ddc07166f96a54$export$70ffa26850098d01).from_binary(a.binary() + '0'.repeat(Number(b.decimal())));
}
function $f13660fa0986c002$export$f8a281af5120de76(a, b) {
    const binary = a.binary();
    return (0, $79ddc07166f96a54$export$70ffa26850098d01).from_binary(binary.substring(0, binary.length - Number(b.decimal())));
}
function $f13660fa0986c002$export$949614a019c2b52f(a, b) {
    if (a.length === b.length) return [
        a,
        b
    ];
    if (a.length > b.length) b = b.padStart(a.length, '0');
    else a = a.padStart(b.length, '0');
    return [
        a,
        b
    ];
}


'use strict';
const $3f6025f2047e00c9$export$af396038be3c831c = {
    and: $f13660fa0986c002$export$21c0ac7fe1cef1b8,
    or: $f13660fa0986c002$export$252bb8b3bbdf6749,
    xor: $f13660fa0986c002$export$6444ef5cd411280c,
    lshift: $f13660fa0986c002$export$10921b7922033856,
    rshift: $f13660fa0986c002$export$f8a281af5120de76
};
class $3f6025f2047e00c9$export$b8bbff9fbc905c82 {
    constructor(op){
        this.op = op;
    }
    execute(a, b) {
        const fn = $3f6025f2047e00c9$export$af396038be3c831c[this.op];
        if (!fn) return [
            null,
            new Error(`Unknown operator: ${this.op}`)
        ];
        return fn(a, b);
    }
}



'use strict';
function $8c33bd62cc6508ee$export$d55a5dc0072c99fa(input) {
    return input.replace(/\s+/g, '');
}
function $8c33bd62cc6508ee$export$45c45a11ff5dd491(input) {
    if (!input || input === '0') return '0000';
    const padded = input.padStart(Math.ceil(input.length / 4) * 4, '0');
    return padded.replace(/(.{4})(?=.)/g, '$1 ');
}
class $8c33bd62cc6508ee$export$a6c1cac4b83a38c5 {
    static from_decimal(input) {
        return (0, $79ddc07166f96a54$export$70ffa26850098d01).create(input || '0');
    }
    static from_binary(input) {
        return (0, $79ddc07166f96a54$export$70ffa26850098d01).from_binary($8c33bd62cc6508ee$export$d55a5dc0072c99fa(input) || '0');
    }
}


'use strict';
const $7149cbf500144ff3$export$ad3969e5d4665b3c = {
    LEFT: 'left',
    RIGHT: 'right'
};
const $7149cbf500144ff3$export$5049e35dbdee0f46 = {
    BINARY: 'binary',
    DECIMAL: 'decimal'
};
class $7149cbf500144ff3$export$ec0a93cb50f62387 {
    /**@type {Record<string, import('./integer').Integer>}*/ last_computation;
    constructor({ on_result: on_result, on_error: on_error, on_operand_sync: on_operand_sync }){
        this.operator = 'and';
        this.result = null;
        this.last_computation = null;
        this.operands = {
            [$7149cbf500144ff3$export$ad3969e5d4665b3c.LEFT]: {
                mode: $7149cbf500144ff3$export$5049e35dbdee0f46.DECIMAL,
                decimal: '0',
                binary: '0000'
            },
            [$7149cbf500144ff3$export$ad3969e5d4665b3c.RIGHT]: {
                mode: $7149cbf500144ff3$export$5049e35dbdee0f46.DECIMAL,
                decimal: '0',
                binary: '0000'
            }
        };
        this.on_result = on_result;
        this.on_error = on_error;
        this.on_operand_sync = on_operand_sync;
    }
    set_operator(op) {
        this.operator = op;
    }
    set_operand_value(side, value) {
        const operand = this.operands[side];
        if (operand.mode === $7149cbf500144ff3$export$5049e35dbdee0f46.DECIMAL) operand.decimal = value;
        else operand.binary = value;
        this.sync_operand(side);
    }
    toggle_mode(side) {
        const op = this.operands[side];
        this.sync_operand(side);
        op.mode = op.mode === $7149cbf500144ff3$export$5049e35dbdee0f46.DECIMAL ? $7149cbf500144ff3$export$5049e35dbdee0f46.BINARY : $7149cbf500144ff3$export$5049e35dbdee0f46.DECIMAL;
        this.on_operand_sync(side, op);
    }
    fill_operand(side, int) {
        const op = this.operands[side];
        op.decimal = int.decimal().toString();
        op.binary = (0, $8c33bd62cc6508ee$export$45c45a11ff5dd491)(int.binary());
        this.on_operand_sync(side, op);
    }
    read_operand(side) {
        const op = this.operands[side];
        if (op.mode === $7149cbf500144ff3$export$5049e35dbdee0f46.DECIMAL) return (0, $8c33bd62cc6508ee$export$a6c1cac4b83a38c5).from_decimal(op.decimal.trim());
        return (0, $8c33bd62cc6508ee$export$a6c1cac4b83a38c5).from_binary(op.binary.trim());
    }
    sync_operand(side) {
        const op = this.operands[side];
        if (op.mode === $7149cbf500144ff3$export$5049e35dbdee0f46.DECIMAL) {
            const [int, err] = (0, $8c33bd62cc6508ee$export$a6c1cac4b83a38c5).from_decimal(op.decimal);
            if (!err) {
                op.binary = (0, $8c33bd62cc6508ee$export$45c45a11ff5dd491)(int.binary());
                this.on_operand_sync(side, op);
            }
        } else {
            const [int, err] = (0, $8c33bd62cc6508ee$export$a6c1cac4b83a38c5).from_binary(op.binary);
            if (!err) {
                op.decimal = int.decimal().toString();
                this.on_operand_sync(side, op);
            }
        }
    }
    compute() {
        const [a, err_a] = this.read_operand($7149cbf500144ff3$export$ad3969e5d4665b3c.LEFT);
        const [b, err_b] = this.read_operand($7149cbf500144ff3$export$ad3969e5d4665b3c.RIGHT);
        if (err_a || err_b) {
            this.result = null;
            this.on_error((err_a || err_b).message);
            return;
        }
        const expr = new (0, $3f6025f2047e00c9$export$b8bbff9fbc905c82)(this.operator);
        const [result, err] = expr.execute(a, b);
        console.log({
            result: result,
            err: err
        });
        if (err) {
            this.result = null;
            this.on_error(err.message);
            return;
        }
        this.result = result;
        this.last_computation = {
            a: a,
            b: b
        };
        this.on_result({
            decimal: result.decimal().toString(),
            binary: (0, $8c33bd62cc6508ee$export$45c45a11ff5dd491)(result.binary())
        });
    }
}






'use strict';
/**
 * @typedef {'normal'|'gained'|'lost'|'lost-struck'} bit_effect
 */ /**
 * @typedef {Object} bit_cell
 * @property {'0'|'1'} value
 * @property {bit_effect} effect
 */ /**
 * @typedef {Object} explanation_model
 * @property {string} title
 * @property {string=} label
 * @property {bit_cell[][]} rows
 * @property {string} operator_name
 */ /**
 * @param {string} operator_name
 * @param {*} left_operand
 * @param {*} right_operand
 * @param {*} computation_result
 * @returns {explanation_model}
 */ function $b4d64ffca6554daf$var$explain_bitwise(operator_name, left_operand, right_operand, computation_result) {
    const normalized = (0, $f13660fa0986c002$export$949614a019c2b52f)(left_operand.binary(), right_operand.binary());
    const left_binary = normalized[0];
    const right_binary = normalized[1];
    const result_binary = computation_result.binary().padStart(left_binary.length, '0');
    return {
        operator_name: operator_name,
        title: 'Bitwise ' + operator_name.toUpperCase(),
        rows: [
            $b4d64ffca6554daf$var$build_bit_cells(left_binary),
            $b4d64ffca6554daf$var$build_bit_cells(right_binary),
            $b4d64ffca6554daf$var$build_result_cells(left_binary, right_binary, result_binary)
        ]
    };
}
/**
 * @param {'lshift'|'rshift'} shift_operator
 * @param {*} left_operand
 * @param {*} right_operand
 * @param {*} computation_result
 * @returns {explanation_model}
 */ function $b4d64ffca6554daf$var$explain_shift(shift_operator, left_operand, right_operand, computation_result) {
    const shift_amount = Number(right_operand.decimal());
    const direction = shift_operator === 'lshift' ? 'left' : 'right';
    const original_binary = left_operand.binary();
    const result_binary = computation_result.binary();
    return {
        title: 'Bitwise ' + shift_operator.toUpperCase(),
        label: (0, $8c33bd62cc6508ee$export$45c45a11ff5dd491)(original_binary) + " \u2014 shift " + shift_amount + ' bit' + (shift_amount === 1 ? '' : 's') + ' to the ' + direction,
        rows: [
            $b4d64ffca6554daf$var$build_shift_cells(shift_operator, original_binary, result_binary, shift_amount)
        ],
        operator_name: shift_operator
    };
}
function $b4d64ffca6554daf$var$build_bit_cells(binary_string) {
    return binary_string.split('').map(function(bit) {
        return {
            value: bit,
            effect: 'normal'
        };
    });
}
function $b4d64ffca6554daf$var$build_result_cells(left_binary, right_binary, result_binary) {
    return result_binary.split('').map(function(result_bit, index) {
        const left_bit = left_binary[index];
        const right_bit = right_binary[index];
        if (result_bit === '1') return {
            value: result_bit,
            effect: 'gained'
        };
        if (result_bit === '0' && (left_bit === '1' || right_bit === '1')) return {
            value: result_bit,
            effect: 'lost'
        };
        return {
            value: result_bit,
            effect: 'normal'
        };
    });
}
function $b4d64ffca6554daf$var$build_shift_cells(shift_operator, original_binary, result_binary, shift_amount) {
    if (shift_amount === 0) return $b4d64ffca6554daf$var$build_bit_cells(result_binary);
    if (shift_operator === 'lshift') {
        const length = result_binary.length;
        return result_binary.split('').map(function(bit, index) {
            return {
                value: bit,
                effect: index >= length - shift_amount ? 'gained' : 'normal'
            };
        });
    }
    // NOTE: right shift
    if (shift_amount >= original_binary.length) return [
        {
            value: '0',
            effect: 'normal'
        }
    ].concat(original_binary.split('').map(function(bit) {
        return {
            value: bit,
            effect: 'lost-struck'
        };
    }));
    const length = original_binary.length;
    return (0, $8c33bd62cc6508ee$export$45c45a11ff5dd491)(original_binary).replace(/\s/g, '').split('').map(function(bit, index) {
        return {
            value: bit,
            effect: index >= length - shift_amount ? 'lost-struck' : 'normal'
        };
    });
}
const $b4d64ffca6554daf$var$explanation_registry = {
    and: $b4d64ffca6554daf$var$explain_bitwise,
    or: $b4d64ffca6554daf$var$explain_bitwise,
    xor: $b4d64ffca6554daf$var$explain_bitwise,
    lshift: $b4d64ffca6554daf$var$explain_shift,
    rshift: $b4d64ffca6554daf$var$explain_shift
};
function $b4d64ffca6554daf$export$213a2150870e14d9(operator_name) {
    const fn = $b4d64ffca6554daf$var$explanation_registry[operator_name];
    if (!fn) throw new Error('Unsupported operator: ' + operator_name);
    return fn;
}
const $b4d64ffca6554daf$var$operator_name_description = Object.freeze({
    and: 'Sets each bit to 1 only if the corresponding bits in both operands are 1.',
    or: 'Sets each bit to 1 if at least one of the corresponding bits is 1.',
    xor: 'Sets each bit to 1 if the corresponding bits differ.',
    lshift: 'Shifts all bits left by x positions, filling with 0s on the right.',
    rshift: 'Shifts all bits right by x positions, dropping the right-most bits.'
});
function $b4d64ffca6554daf$export$9597e5aac7d761ac(model) {
    const dialog = document.createElement('dialog');
    dialog.className = 'expr-explanation-dialog';
    const heading = document.createElement('h2');
    heading.textContent = model.title;
    const description = document.createElement('p');
    description.innerText = $b4d64ffca6554daf$var$operator_name_description[model.operator_name];
    dialog.append(heading, description);
    if (model.label) {
        const label = document.createElement('div');
        label.className = 'expr-explanation__shift-label';
        label.textContent = model.label;
        dialog.appendChild(label);
    }
    model.rows.forEach(function(row, index) {
        if (index === 2) {
            const divider = document.createElement('div');
            divider.className = 'expr-explanation__divider';
            dialog.appendChild(divider);
        }
        const row_element = document.createElement('div');
        row_element.className = 'expr-explanation__row';
        row.forEach(function(cell) {
            const span = document.createElement('span');
            span.className = 'bit ' + $b4d64ffca6554daf$var$effect_to_class(cell.effect);
            span.textContent = cell.value;
            row_element.appendChild(span);
        });
        dialog.appendChild(row_element);
    });
    const close_button = document.createElement('button');
    close_button.classList.add('expr-explanation__close');
    close_button.textContent = 'OK';
    close_button.addEventListener('click', function() {
        dialog.close();
    });
    dialog.appendChild(close_button);
    dialog.addEventListener('close', function() {
        dialog.remove();
    });
    return dialog;
}
function $b4d64ffca6554daf$var$effect_to_class(effect) {
    switch(effect){
        case 'gained':
            return 'bit--gained';
        case 'lost':
            return 'bit--lost';
        case 'lost-struck':
            return 'bit--lost bit--strikethrough';
        default:
            return '';
    }
} /******************************************************************
 * UI — CLEAN AND SMALL
 ******************************************************************/ 


const $b67b760f14124548$var$ROW_TEMPLATE = `
<div class="expr-row__inputs">
    <div class="expr-row__operand">
        <div class="expr-row__decimal">
            <input type="text" placeholder="Decimal" inputmode="numeric" />
        </div>
        <button type="button" class="expr-row__swap-btn" data-side="a" title="Swap input mode">&#8693;</button>
        <div class="expr-row__binary">
            <input type="text" placeholder="Binary" readonly disabled />
        </div>
    </div>

    <div class="expr-row__operator">
        <select>
            <option value="and">AND</option>
            <option value="or">OR</option>
            <option value="xor">XOR</option>
            <option value="lshift">LSHIFT</option>
            <option value="rshift">RSHIFT</option>
        </select>
    </div>

    <div class="expr-row__operand">
        <div class="expr-row__decimal">
            <input type="text" placeholder="Decimal" inputmode="numeric" />
        </div>
        <button type="button" class="expr-row__swap-btn" data-side="b" title="Swap input mode">&#8693;</button>
        <div class="expr-row__binary">
            <input type="text" placeholder="Binary" readonly disabled/>
        </div>
    </div>

    <button type="button" class="expr-row__equals">=</button>
</div>

<div class="expr-row__result">
    <div class="expr-row__result-decimal-container">
        <span class="expr-row__result-decimal"></span>
        <button type="button" class="expr-row__explain">Explain</button>
    </div>
    <span class="expr-row__result-binary"></span>
</div>

<div class="expr-row__error"></div>
`;
function $b67b760f14124548$var$cache_dom(root) {
    const operands = root.querySelectorAll('.expr-row__operand');
    const cache_operand = (el)=>({
            decimal: el.querySelector('.expr-row__decimal input'),
            binary: el.querySelector('.expr-row__binary input'),
            swap: el.querySelector('.expr-row__swap-btn')
        });
    return {
        operands: {
            [(0, $7149cbf500144ff3$export$ad3969e5d4665b3c).LEFT]: cache_operand(operands[0]),
            [(0, $7149cbf500144ff3$export$ad3969e5d4665b3c).RIGHT]: cache_operand(operands[1])
        },
        operator: root.querySelector('.expr-row__operator select'),
        equals: root.querySelector('.expr-row__equals'),
        result: root.querySelector('.expr-row__result'),
        result_decimal: root.querySelector('.expr-row__result-decimal'),
        result_binary: root.querySelector('.expr-row__result-binary'),
        explain_btn: root.querySelector('.expr-row__explain'),
        error: root.querySelector('.expr-row__error')
    };
}
function $b67b760f14124548$export$7f2921fcd5dc3626(prefill = null) {
    const row = document.createElement('div');
    row.className = 'expr-row';
    row.innerHTML = $b67b760f14124548$var$ROW_TEMPLATE;
    const dom = $b67b760f14124548$var$cache_dom(row);
    const controller = new (0, $7149cbf500144ff3$export$ec0a93cb50f62387)({
        on_result: render_result,
        on_error: render_error,
        on_operand_sync: render_operand
    });
    function render_result(data) {
        dom.error.classList.remove('expr-row__error--visible');
        dom.result.classList.add('expr-row__result--visible');
        dom.result_decimal.textContent = data.decimal;
        dom.result_binary.textContent = data.binary;
    }
    function render_error(msg) {
        dom.error.textContent = msg;
        dom.error.classList.add('expr-row__error--visible');
        dom.result.classList.remove('expr-row__result--visible');
    }
    function render_operand(side, operator) {
        const operand = dom.operands[side];
        operand.decimal.value = operator.decimal;
        operand.binary.value = operator.binary;
        const is_decimal = operator.mode === (0, $7149cbf500144ff3$export$5049e35dbdee0f46).DECIMAL;
        operand.decimal.toggleAttribute('readonly', !is_decimal);
        operand.decimal.toggleAttribute('disabled', !is_decimal);
        operand.binary.toggleAttribute('readonly', is_decimal);
        operand.binary.toggleAttribute('disabled', is_decimal);
    }
    for (const side of Object.values((0, $7149cbf500144ff3$export$ad3969e5d4665b3c))){
        const d = dom.operands[side];
        d.swap.addEventListener('click', ()=>{
            controller.toggle_mode(side);
        });
        d.decimal.addEventListener('input', ()=>{
            controller.set_operand_value(side, d.decimal.value);
        });
        d.binary.addEventListener('input', ()=>{
            controller.set_operand_value(side, d.binary.value);
        });
    }
    dom.operator.addEventListener('change', ()=>{
        controller.set_operator(dom.operator.value);
    });
    dom.equals.addEventListener('click', ()=>{
        controller.compute();
    });
    dom.explain_btn.addEventListener('click', function() {
        const last_computation = controller.last_computation;
        const computation_result = controller.result;
        if (!last_computation || !computation_result) return;
        const left_operand = last_computation.a;
        const right_operand = last_computation.b;
        const operator_name = controller.operator;
        const explain_function = (0, $b4d64ffca6554daf$export$213a2150870e14d9)(operator_name);
        const model = explain_function(operator_name, left_operand, right_operand, computation_result);
        const dialog = (0, $b4d64ffca6554daf$export$9597e5aac7d761ac)(model);
        dom.result.closest('.expr-row').appendChild(dialog);
        dialog.showModal();
    });
    if (prefill) controller.fill_operand((0, $7149cbf500144ff3$export$ad3969e5d4665b3c).LEFT, prefill);
    else {
        controller.sync_operand((0, $7149cbf500144ff3$export$ad3969e5d4665b3c).LEFT);
        controller.sync_operand((0, $7149cbf500144ff3$export$ad3969e5d4665b3c).LEFT);
    }
    return {
        el: row,
        controller: controller
    };
}


'use strict';
const $e73bf42412feb220$var$rows = [];
const $e73bf42412feb220$var$container = document.getElementById('rows');
function $e73bf42412feb220$var$add_row(prefill = null) {
    const row = (0, $b67b760f14124548$export$7f2921fcd5dc3626)(prefill);
    $e73bf42412feb220$var$rows.push(row);
    $e73bf42412feb220$var$container.appendChild(row.el);
}
$e73bf42412feb220$var$add_row(null);
document.getElementById('add-row-btn').addEventListener('click', ()=>{
    const prev = $e73bf42412feb220$var$rows[$e73bf42412feb220$var$rows.length - 1];
    $e73bf42412feb220$var$add_row(prev?.controller.result ?? null);
});


//# sourceMappingURL=bitwise.5ca00069.js.map
